module.exports = __webpack_public_path__ + "img/rd-nirmatrelvir.272b45ba.png";